import React from "react";

const gridView: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="currentcolor" fillRule="nonzero" transform="translate(.063 .218)">
                    <path d="M16.609 16.609h-4.152v-4.152h4.152v4.152zm-6.228 0H6.228v-4.152h4.153v4.152zm-6.229 0H0v-4.152h4.152v4.152zM16.61 10.38h-4.152V6.228h4.152v4.153zm-6.228 0H6.228V6.228h4.153v4.153zm-6.229 0H0V6.228h4.152v4.153zM16.61 4.152h-4.152V0h4.152v4.152zm-6.228 0H6.228V0h4.153v4.152zm-6.229 0H0V0h4.152v4.152z"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(gridView);
